import React from 'react';
import { AdvertorialLanding } from './components/advertorial/AdvertorialLanding';
export function App() {
  return <AdvertorialLanding data-id="element-0" />;
}